import { ColumnState, FilterModel } from 'ag-grid-community'
import { State } from './reducer'
import { StickyGridState, WindowSettingsDto } from './types'
import { TemplateOption } from '../../containers/TradingList/helpers'

export const loadWindowSettings = (settings: WindowSettingsDto) =>
  ({ type: 'settings.loadWindowSettings', payload: { settings } } as const)
export type LoadWindowSettingsAction = ReturnType<typeof loadWindowSettings>

export const loadWindowSettingsSuccess = (settings: WindowSettingsDto) =>
  ({
    type: 'settings.loadWindowSettingsSuccess',
    payload: { settings }
  } as const)
export type LoadWindowSettingsSuccessAction = ReturnType<
  typeof loadWindowSettingsSuccess
>

export const handleWindowSettings = () =>
  ({ type: 'settings.handleWindowSettings' } as const)
export type HandleWindowSettingsAction = ReturnType<typeof handleWindowSettings>

type MaybeStickyGridState = StickyGridState | null | undefined
export type GridKeys = KeysWithValsOfType<State, MaybeStickyGridState>

export const updateGridState = (
  gridName: GridKeys,
  columnState: ColumnState[],
  filterModel: FilterModel | null
) =>
  ({
    type: 'settings.updateGridState',
    payload: { gridName, columnState, filterModel }
  } as const)
export type UpdateGridStateAction = ReturnType<typeof updateGridState>

export const saveListTradingTemplateSelection = (
  template: TemplateOption,
  isSpread: boolean
) =>
  ({
    type: 'settings.saveListTradingTemplateSelection',
    payload: { template, isSpread }
  } as const)
export type SaveListTradingTemplateSelectionAction = ReturnType<
  typeof saveListTradingTemplateSelection
>

export const clearSettings = () => ({ type: 'settings.clearSettings' } as const)
export type ClearSettingsAction = ReturnType<typeof clearSettings>

export type SettingsAction =
  | HandleWindowSettingsAction
  | LoadWindowSettingsAction
  | LoadWindowSettingsSuccessAction
  | SaveListTradingTemplateSelectionAction
  | UpdateGridStateAction
  | ClearSettingsAction
